import React from 'react';

import { Container, SectionBody, SectionTitle } from './styles';

interface SectionProps {
	children?: React.ReactNode;
	title?: string;
}

const Section = ({ title, children }: SectionProps) => (
	<Container>
		{title && <SectionTitle>{title}</SectionTitle>}
		<SectionBody>{children}</SectionBody>
	</Container>
);

export default Section;
